import { render } from "./TeamSide.vue?vue&type=template&id=28120248"
import script from "./TeamSide.vue?vue&type=script&lang=js"
export * from "./TeamSide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__